import {NativeStackHeaderProps} from "@react-navigation/native-stack";
import {StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";
import {useEvent} from "@/lib/providers/EventProvider";
import EventHeader from "@/lib/headers/EventHeader";
import {useGroup} from "@/lib/providers/GroupProvider";
import GroupHeader from "@/lib/headers/GroupHeader";
import {useProfile} from "@/lib/providers/ProfileProvider";
import ProfileHeader from "@/lib/headers/ProfileHeader";
import {useChat} from "@/lib/providers/ChatProvider";
import ChatHeader from "@/lib/headers/ChatHeader";

export default function WebHeader(props: NativeStackHeaderProps) {
    const {event} = useEvent();
    const {group} = useGroup();
    const {profile} = useProfile();
    const {currentChat} = useChat();

    return (
        <View style={styles.outer}>
            <View style={styles.container}>
                <Text style={styles.title}>{props.options.title}</Text>
                {!!props.options.headerRight &&
                    <View style={styles.headerRight}>
                        {event && <EventHeader/>}
                        {group && <GroupHeader/>}
                        {profile && <ProfileHeader/>}
                        {currentChat && <ChatHeader/>}
                    </View>
                }
            </View>
        </View>
    )
}

export const styles = StyleSheet.create({
    outer: {
        width: "100%",
        backgroundColor: Color.Background,
    },
    container: {
        width: "100%",
        maxWidth: 664,
        marginHorizontal: "auto",
        backgroundColor: Color.Background,
        height: 91,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingVertical: 12,
        gap: 8,
    },
    title: {
        fontSize: 24,
        fontWeight: 500,
        color: Color.PrimaryText,
    },
    headerRight: {
        position: "absolute",
        right: 0,
    },
})